"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.API_TOKENS, (table)=>{
        table.string('fk_sso_client_id', 20);
        table.index('fk_sso_client_id');
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.API_TOKENS, (table)=>{
        table.dropIndex('fk_sso_client_id');
        table.dropColumn('fk_sso_client_id');
    });
};
